import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import TaskApiService from '../../api/TaskApiService';
import dayjs from 'dayjs';

const PrinterFriendlyTask = () => {
    const { t } = useTranslation();
    const params = useParams();
    const [taskId] = useState(params.taskId);
    const [taskData, setTaskData] = useState({});
    const [taskHistory, setTaskHistory] = useState([]);

    const taskService = new TaskApiService();

    useEffect(() => {
        async function fetchData () {
            const thisTaskData = await taskService.getTask(taskId);
            setTaskData(thisTaskData.data);
            const thisTaskHistory = await taskService.getTaskHistory(taskId);
            setTaskHistory(thisTaskHistory.data);
        }
        void fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [taskId]);

    return <div>
        <div>
            <b>
                {t('common.id')}:&nbsp;
                <a href={'/Task/' + taskId}>{taskId}</a>
            </b>
        </div>
        <div>
            <b>
                {t('fieldName.shortDescription')}:&nbsp;
                <a href={'/Task/' + taskId}>{taskData?.shortDescription}</a>
            </b>
        </div>
        <div>
            <table id={'printTaskDataTable'} cellSpacing={'0'} cellPadding={'3'} border={'1'}>
                <tbody>
                    <tr>
                        <td>{t('fieldName.reportedBy')}</td>
                        <td>{taskData?.reportedUser?.username}</td>
                    </tr>
                    <tr>
                        <td>{t('fieldName.reportedOn')}</td>
                        <td>{dayjs(taskData?.reportedDate).format('MM/DD/YYYY hh:mm:ss A')}</td>
                    </tr>
                    <tr>
                        <td>{t('taskPage.field.projectLocation')}</td>
                        <td>{taskData?.project?.pjName}</td>
                    </tr>
                    <tr>
                        <td>{t('fieldName.category')}</td>
                        <td>{taskData?.category?.localizedName ?? taskData?.category?.ctName}</td>
                    </tr>
                    <tr>
                        <td>{t('fieldName.priority')}</td>
                        <td>{taskData?.priority?.localizedName ?? taskData?.priority?.prName}</td>
                    </tr>
                    <tr>
                        <td>{t('fieldName.assignedTo')}</td>
                        <td>{taskData?.assignedToUser?.username}</td>
                    </tr>
                    <tr>
                        <td>{t('fieldName.status')}</td>
                        <td>{taskData?.status?.localizedName ?? taskData?.status?.stName}</td>
                    </tr>
                    {taskData?.customColumnData?.map((data) => {
                        return(
                            <tr key={data.id}>
                                <td>{data.columnName}</td>
                                <td>{data.columnValue}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            <br/>
            <table id={'posts_table'} cellSpacing={3} cellPadding={0} border={0}>
                <tbody>
                    {taskHistory?.filter(data => data.taskChangeType === 'Comment' || data.taskChangeType === 'comment')
                        .map((data) => {
                            return (
                                <tr key={data.taskChange}>
                                    <td className={'cmt'}>
                                        <table width={'100%'}>
                                            <tbody>
                                                <tr>
                                                    <td align={'left'}>
                                                        <span className={'pst'}>
                                                            {t('taskHistory.printedCommentLine', { user: data.taskChangeUser, time: dayjs(data.taskChangeTime).format('MM/DD/YYYY hh:mm:ss A') })}
                                                        </span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <table border={0}>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <span className={'cmt_text'}>
                                                            <p dangerouslySetInnerHTML={{ __html: data.taskChange }} />
                                                        </span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            );
                        },
                        )}
                </tbody>
            </table>
        </div>
    </div>;
};

export default PrinterFriendlyTask;
